import { useEffect } from 'react';
import { publicUrl } from '../utils/assets';
import './LeadFormModal.css';

// Kylas lead-capture form, loaded in an iframe so its script runs fresh on every open.
const FORM_URL = publicUrl('lead-form.html');

function LeadFormModal({ open, onClose }) {
  useEffect(() => {
    if (!open) return undefined;

    const onKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
    };
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    window.addEventListener('keydown', onKeyDown);

    return () => {
      document.body.style.overflow = prevOverflow;
      window.removeEventListener('keydown', onKeyDown);
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="lf-overlay" onClick={onClose}>
      <div
        className="lf-dialog"
        role="dialog"
        aria-modal="true"
        aria-label="Vending machine enquiry"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="lf-header">
          <h2 className="lf-title">Get a vending machine</h2>
          <button className="lf-close" type="button" aria-label="Close" onClick={onClose}>
            ×
          </button>
        </div>
        <iframe className="lf-frame" src={FORM_URL} title="Vending machine enquiry form" />
      </div>
    </div>
  );
}

export default LeadFormModal;
